module.exports = __webpack_public_path__ + "static/media/Story-02.b85756bb.jpg";